import React from 'react';
import styles from './Contact.module.css';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Contact: React.FC = () => {
    return (
        <div className={styles.contact}>
            <h1>Contact Us</h1>
            <p><FaEnvelope /> Email: <a href="mailto:mobdramamusic@gmail.com">mobdramamusic@gmail.com</a></p>
            <p><FaMapMarkerAlt /> Location: Bartlett, IL</p>
            <form action="https://formspree.io/f/xvgpgoza" method="POST" className={styles.contactForm}>
                <label htmlFor="email">Your email:</label>
                <input type="email" id="email" name="email" required />
                <label htmlFor="message">Your message:</label>
                <textarea id="message" name="message" rows={4} required></textarea>
                <button type="submit">Send</button>
            </form>
        </div>
    );
};

export default Contact;